//引入接口文档
import req from '@/utils/req.js'

//健康基础测评更新
export function updateToolContent(params) {
  return req.put("/admin/health-tool-test",params);
}
//健康基础测评添加,并获取ID
export function addToolContent(params) {
  return req.post("/admin/health-tool-test/insertReturnId",params);
}

//健康基础测评列表查询
export function getLeftList(params) {
  return req.post("/admin/health-tool-test/list",params);
}

// //健康基础测评分页查询
// export function getLeftList(params) {
//   return req.post("/admin/health-tool-test/page",params);
// }

//健康基础测评详情
export function getDetail(params) {
  return req.get(`/admin/health-tool-test/${params.id}`);
}

//健康基础测评删除
export function deleteType(params) {
  return req.delete(`/admin/health-tool-test/${params.id}`);
}
//获取关键康复工具问卷列表
export function getRehabilitationList(params) {
  return req.post("/admin/exam-paper-selection/list",params);
}
//获取关键康复工具问卷详情
export function getRehabilitationDetaial(params) {
  return req.post("/admin/exam-paper-selection-item/listByParam",params);
}
//添加关键康复工具问卷
export function addRehabilitation(params) {
  return req.post("/admin/exam-paper-selection-item/saveBatch",params);
}

//疾病类型列表查询
export function getDiseaseType(params) {
  return req.get('/admin/disease-type',params);
}